var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadge = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1a5 5 0 0 0-3.806 8.242l-.932 5.124a.75.75 0 0 0 1.001.836L8 13.801l3.737 1.401a.75.75 0 0 0 1-.836l-.93-5.124A5 5 0 0 0 8 1zM5 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm5.482 4.342A4.977 4.977 0 0 1 8 11a4.99 4.99 0 0 1-2.482-.658l-.544 2.992 2.763-1.036a.75.75 0 0 1 .526 0l2.763 1.036-.544-2.992z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadge);
export default ForwardRef;